var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacSpecificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.179 3.19981L2.33673 0.104764H0V5.93686H1.34736V1.7685L2.463 5.93686H3.60014L4.67414 1.7685V5.93686H6.33719V0.104764H3.97895L3.179 3.19981ZM8.67391 0.104764L6.86309 5.93686H8.31591L8.67391 4.77891H10.2315L10.5687 5.93686H12.4003L10.5687 0.104764H8.67391ZM8.98959 3.51549L9.45236 1.83094L9.93663 3.51549H8.98959ZM15.1797 4.65194C14.9272 4.65194 14.7162 4.54648 14.5691 4.31545C14.4221 4.10523 14.3374 3.66258 14.3589 3.01041C14.3589 1.89477 14.633 1.32586 15.2012 1.32586C15.3906 1.32586 15.58 1.40981 15.7278 1.5784C15.8749 1.74699 15.9595 2.02035 15.9595 2.42068L17.6226 2.33673C17.5802 1.62072 17.3485 1.0525 16.9281 0.63136C16.5069 0.210222 15.9179 0 15.1388 0C14.318 0 13.6651 0.273358 13.2017 0.842276C12.7382 1.4105 12.5072 2.14732 12.5072 3.05273C12.5072 3.97895 12.7597 4.69496 13.244 5.22086C13.7283 5.74746 14.3811 6 15.1596 6C15.8124 6 16.3807 5.81059 16.8226 5.43178C17.2861 5.05296 17.5386 4.50555 17.6226 3.78955L15.9803 3.68409C15.9165 4.33626 15.664 4.65194 15.1797 4.65194Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacSpecificationIcon);
export default __webpack_public_path__ + "static/media/mac_specification_icon.6490527b6aa11f7ffe3f9c613b1255a5.svg";
export { ForwardRef as ReactComponent };